export default "__VITE_ASSET__t3tIiXuZ__"